/*
 * Model class ResolutionCenter
 */
export default class ResolutionCenter {
	constructor(initial_list, $content, $sce) {
		this.initial_list = initial_list;
		this.content = $content;
		this.sce = $sce;
	}

	getInitialList() {
		return this.initial_list;
	}

	getRequestList() {	
		var list = [];
		
		for (var i in this.content) {
			if (i.indexOf('request-assistance-list') != -1) {
				list.push(this.content[i]);
			}
		}
		
		return list;
	}
	
	requestCallPost($post) {
		return new Promise((resolve, reject)=>{
			$.post('/user/assistance/request-a-call', $post, function(data){
				resolve(data);
			});
		});
	}

	resolveSelectSecond(group_id) {
		return new Promise((resolve, reject)=> {
			$.post('/user/portal/resolution_center_post/', {group_id: group_id}, function(data){
				resolve(data);
			});
		});
	}

	getGroupById(group_id) {
		return new Promise((resolve, reject)=> {
			$.post('/user/portal/resolution_center_post/', {group_id: group_id}, function(data){
				resolve(data);
			});
		});
	}

	getArticle(article_id) {
		return new Promise((resolve, reject)=> {
			$.post('/user/portal/resolution_center_post/', {article_id: article_id}, function(data){
				resolve(data);
			});
		});
	}
}
